import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { TradingOfferOperationComment } from 'types/TradingOfferOperation';

const formatDateTime = (date: Date | string | undefined) => {
  if (!date) return '-';
  return format(new Date(date), "dd MMM yyyy · HH:mm'h'", { locale: es });
};

type TradingOfferOperationDetailCommentsProps = {
  comments: TradingOfferOperationComment[];
};

const TradingOfferOperationDetailComments: FC<
  TradingOfferOperationDetailCommentsProps
> = ({ comments }) => {
  const { t } = useTranslate();

  return (
    <div className="nk-block">
      <div className="card card-bordered">
        <div className="card-inner">
          <h6 className="card-title mb-3">
            <em className="icon ni ni-comments text-primary mr-2" />
            {t('Comments')}
          </h6>
          {comments?.length ? (
            <ul className="list-unstyled mb-0">
              {comments.map((comment) => (
                <li
                  key={comment._id}
                  className="d-flex align-items-start py-3 border-bottom"
                >
                  <div className="user-avatar user-avatar-sm bg-info-dim mr-3 mt-1">
                    <span>
                      {typeof comment.user === 'string'
                        ? comment.user.slice(0, 2).toUpperCase()
                        : 'U'}
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                      <strong className="fs-13px">{comment.user}</strong>
                      <span className="text-soft fs-12px">
                        {formatDateTime(comment.createdAt)}
                      </span>
                    </div>
                    <p className="fs-13px mb-0 mt-1">{comment.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-soft fs-13px mb-0">{t('NoComments')}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailComments;
